/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/overlays/achievements-overlay',['require','jquery','underscore','core/base-screen','core/overlay-screen','core/engine','modernizr'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  var _ = require('underscore');
  var BaseScreen = require('core/base-screen');
  var OverlayScreen = require('core/overlay-screen');
  var Engine = require('core/engine');
  var Modernizr = require('modernizr');

  /*****************************************************************************************************************///}

  var AchievementsOverlay = OverlayScreen.extend({

    leftBtn: null,
    rightBtn: null,
    itemsMC: null,

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      BaseScreen.prototype.initialize.apply(this, arguments);
      //console.log('achievements', Engine.module('Achievement').achievementsArr);
      this.model.set('achievementsArr', Engine.module('Achievement').achievementsArr);
    },

    onBeforeShow: function()
    {
      this.leftBtn = this.$el.find('[data-mc=left_btn_mc]');
      this.rightBtn = this.$el.find('[data-mc=right_btn_mc]');
      this.itemsMC = this.$el.find('[data-mc=items_mC]');

      OverlayScreen.prototype.onBeforeShow.apply(this, arguments);
    },

    onShow: function()
    {
      this.buildTrophies();
      this.finish();
    },

    onLeftBtnClickHandler: function($e)
    {
      this.leftPress();
    },

    onRightBtnClickHandler: function($e)
    {
      this.rightPress();
    },

    leftPress: function()
    {
      this.disableArrows();
      this.itemsLeft();
      this.evalButtons();
    },

    rightPress: function()
    {
      this.disableArrows();
      this.itemsRight();
      this.evalButtons();
    },

    evalButtons: function()
    {
      this.disableArrows();
      if (this.itemsMC.width() > 930)
      {
        if (this.itemsMC.position().left < 0)
        {
          this.leftBtn.enable();
        }
        if (this.itemsMC.position().left + this.itemsMC.width() > 930)
        {
          this.rightBtn.enable();
        }
      }
    },

    disableArrows: function()
    {
      this.leftBtn.disable();
      this.rightBtn.disable();
    },

    buildTrophies: function()
    {
      var $ach;
      var $width = 0;

      //var $xPos = 0;
      //var $yPos = 0;

      var $achArr = this.$el.find('.achievement-item');
      var $columns = Math.ceil($achArr.length / 2) + 1;

      _.each($achArr, function(achEl) {
        var $achAsset = $(achEl);
        $ach = Engine.module('Achievement').getAchievementByCode($achAsset.attr('id'));

        if ($achAsset.find('[data-mc=description_mc]'))
        {
          $achAsset.find('[data-mc=description_mc]').hide();
        }
        //$achAsset.id = $ach.id;
        //$achAsset.x = $xPos;
        //$achAsset.y = $yPos;
        //this.itemsMC.addChild($achAsset);

        //$achBtn = new Button($achAsset);
        if (Modernizr.touch)
        {
          $achAsset.on('click', $.proxy(this.toggleTrophy, this, $achAsset));
        }
        else
        {
          $achAsset.on('mouseover', $.proxy(this.onTrophyOverHandler, this, $achAsset));
          $achAsset.on('mouseout', $.proxy(this.onTrophyOutHandler, this, $achAsset));
        }

        //$achBtn.onClick = onTrophyClickHandler;

        $achAsset.find('[data-mc=item_mc] [data-mc=title_tf]').html($ach.title);
        //NLUtils.centerTextFieldVertically($achAsset.item_mc.text_tf, 35);
        //$achAsset.item_mc.score_tf.text = $ach.complete;

        //$achAsset.item_mc.gotoAndStop('trophy_' + $ach.id);
        if ($ach.complete)
        {
          $achAsset.find('[data-mc=description_mc] [data-mc=description_tf]').html($ach.description);
          $achAsset.find('.badge-gfx').addClass('is-complete');//item_mc.gotoAndStop(1);
          //$achBtn.disable();
        }
        else
        {
          $achAsset.find('[data-mc=description_mc] [data-mc=description_tf]').html($ach.hint);
        }
        $width = Math.max($width, $achAsset.width());

      }, this);
      //console.log('width', $width, $columns);
      this.$el.find('[data-mc=items_mc]').css('width', $columns * ($width + 20));
      //panelUpdated();
    },

    onTrophyOverHandler: function($achAsset, $e)
    {
      //var $achAsset = $e.currentTarget;
      $achAsset.find('[data-mc=description_mc]').show();
      //$achAsset.addEventListener(MouseEvent.ROLL_OUT, onTrophyOutHandler);
    },

    onTrophyOutHandler: function($achAsset, $e)
    {
      //var $achAsset = $e.currentTarget;
      $achAsset.find('[data-mc=description_mc]').hide();
      //$achAsset.removeEventListener(MouseEvent.ROLL_OUT, onTrophyOutHandler);
    },

    toggleTrophy: function($achAsset)
    {
      if ($achAsset.find('[data-mc=description_mc]').css('display') === 'none')
        $achAsset.find('[data-mc=description_mc]').show();
      else
        $achAsset.find('[data-mc=description_mc]').hide();
    }

  /*****************************************************************************************************************///}

  });

  return AchievementsOverlay;

});

